<template>
  <list-page-layout class="lease-list-page" :pageSize="pageSize" :currentPage="pageIndex" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">委托租赁分成收益报表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" placeholder="请输入物料名称/物料编码" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-select v-model="Search.Brand" class="form-item" @change="changeBrand" placeholder="请选择或输入品牌" clearable filterable>
            <el-option
            v-for="item in Brand"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="机型">
        <el-select v-model="Search.Machine" class="form-item" placeholder="请选择或输入机型" clearable filterable>
            <el-option
            v-for="item in Machine"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="模块">
        <el-select v-model="Search.Module" class="form-item" placeholder="请选择或输入模块" clearable filterable>
            <el-option
            v-for="item in Module"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="批次号">
        <el-input class="form-input" v-model="Search.LotCode" placeholder="请输入批次号" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="区域">
        <el-select 
        v-model="Search.Region"
        class="form-item"
        placeholder="请选择或输入区域"
        filterable
        clearable>
            <el-option
            v-for="item in Regions"
            :key="item.Name"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch" style="width: 120px">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tabs" slot="tabs">
      <el-tabs class="tab" :value="currentTab" @tab-click="handleTabClick">
        <el-tab-pane label="租赁中" name="租赁中"></el-tab-pane>
        <el-tab-pane label="待收款" name="待收款"></el-tab-pane>
        <el-tab-pane label="已收款" name="已收款"></el-tab-pane>
      </el-tabs>
      <div class="payment_box">
        已收款：<span class="green">{{receiptFee | amount}}</span>
      </div>
    </div>
      <complex-grid v-loading="IsLoading" element-loading-text="加载中" :config="tableConfig" :data="List" slot="main-content">
        <template slot="sub-header" scope="props">
          <el-col :span="20">
            <span style="margin-right: 20px">流水号：{{props.row.WaterCode | NullShow}}</span>
            <span style="margin-right: 20px">批次号：{{props.row.BatchCode}}</span>
            <span style="margin-right: 20px">租赁价格：{{props.row.UnitPrice | amount}}</span>
            <span style="margin-right: 20px">分成比例：{{props.row.Scale | Scale}}</span>
            <span style="margin-right: 20px">累计收益：{{props.row.Profit | amount}}</span>
            <span style="margin-right: 20px">已收款：{{props.row.Receipted | amount}}</span>
            <span style="margin-right: 20px">区域：{{props.row.Area}}</span>
          </el-col>
          <el-col :span="2" :offset="2">
          状态：<span style="color: red">{{props.row.State}}</span>
        </el-col>
        </template>
        <template slot="ProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.ItemName}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.ItemCode}}</p>
        </template>
        <template slot="CustomerProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.CustomerItemName | NullShow}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.CustomerItemCode | NullShow}}</p>
        </template>
        <template slot="ProductConditionName" scope="props">
          <el-tag :type="props.row.ItemQualityName | ConditionColor">{{props.row.ItemQualityName}}</el-tag>
        </template>
        <template slot="Brand" scope="props">
          <p type="primary">{{props.row.Brand}}</p>
        </template>
        <template slot="Machine" scope="props">
          <p type="primary">{{props.row.Machine}}</p>
        </template>
        <template slot="Module" scope="props">
          <p type="primary">{{props.row.Module}}</p>
        </template>
        <template slot="StartTime" scope="props">
          <p type="primary">{{props.row.StartTime | date('YYYY-MM-DD')}}</p>
        </template>
        <template slot="EndTime" scope="props">
          <p type="primary">{{props.row.EndTime | date('YYYY-MM-DD') | NullDate}}</p>
        </template>
        <template slot="Quantity" scope="props">
          <p type="primary">{{props.row.Quantity}}</p>
        </template>
        <template slot="action-bar" scope="props">
          <el-button type="text" @click.native="toDetail(props)">查看</el-button>
        </template>
      </complex-grid>
  </list-page-layout>
</template>

<script>
import Countdown from '@/components/common/Countdown'
import ListPageLayout from '@/components/common/ListPageLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Product: null,
        Brand: null,
        Machine: null,
        Module: null,
        Region: null,
        LotCode: null,
      },
      Regions: null,
      Brand: [],
      Machine: [],
      Module: [],
      pageSize: 10,
      pageIndex: 1,
      tableConfig: {
        dataPrefix: 'LotList',
        column: [
          {
            label: '物料名称/编码',
            slot: 'ProductName',
            width: '200px',
          },
          {
            label: '客户物料名称/编码',
            slot: 'CustomerProductName',
            width: '200px',
          },
          {
            label: '品项',
            slot: 'ProductConditionName',
            width: '140px',
          },
          {
            label: '品牌',
            slot: 'Brand',
          },
          {
            label: '机型',
            slot: 'Model',
            width: '120px',
          },
          {
            label: '模块',
            slot: 'Module',
          },
          {
            label: '数量',
            slot: 'Quantity',
          },
          {
            label: '开始时间',
            slot: 'StartTime',
            width: '120px',
          },
          {
            label: '结束时间',
            slot: 'EndTime',
            width: '120px',
          },
          {
            label: '操作',
            collapse: true,
            key: 'action-bar',
            class: 'text-center',
            width: '80px',
          },
        ],
      },
      IsLoading: false,
      tableData: [],
      List: [],
      total: 0,
      receiptFee: null,
      currentTab: '租赁中',
      listURL: process.env.API_HOST + '/finance/RentalOrder/Distribution/Report',
      sorts: ['日立', 'NCR', '迪堡', 'WINCOR', '运通', '御银', '富士通', '怡化', 'OKI', '东信', '恒银', '晓星', '新达通', '科堡', 'LG', 'NMD', '其他品牌'],  // 品牌用来排序的数组
    }
  },
  methods: {
    toDetail: function(props) {
      if (props.row.EntrustCode) {
        this.$router.push('/entrust/' + props.row.EntrustCode)
      } else {
        this.$message.error('抱歉！此委托订单不存在')
      }
    },
    initTotal() {
      o(`Partner/Services.GetCurrentCustomer()`).get().then(({ data }) => {
        let CustomerCode = data.CustomerCode
        let URL = process.env.API_HOST + '/finance/RentalOrder/Distribution/Total?code=' + CustomerCode
        this.$http.get(URL).then(({response}) => {
          this.receiptFee = response
        }).catch((response) => {})
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    handleSearch() {
      this.IsLoading = true
      let filters = ''
      if (this.Search.Product) {
        filters += '&input.material=' + this.Search.Product
      }
      if (this.Search.Machine) {
        filters += '&input.machine=' + this.Search.Machine
      }
      if (this.Search.LotCode) {
        filters += '&input.batchCode=' + this.Search.LotCode
      }
      if (this.Search.Brand) {
        filters += '&input.brand=' + this.Search.Brand
      }
      if (this.Search.Module) {
        filters += '&input.module=' + this.Search.Module
      }
      if (this.Search.Module) {
        filters += '&input.module=' + this.Search.Module
      }
      if (this.Search.Region) {
        filters += '&input.area=' + this.Search.Region
      }
      if (this.currentTab) {
        filters += '&input.state=' + this.currentTab
      }
      let URL = this.listURL + '?input.pageSize=' + this.pageSize + '&input.pageIndex=' + this.pageIndex + filters
      this.$http.get(URL).then((response) => {
        this.IsLoading = false
        const data = response.data
        data.List.forEach(Lists => {
          const LotList = []
          const Lot = {
            ItemCode: Lists.ItemCode,
            ItemName: Lists.ItemName,
            ItemQuality: Lists.ItemQuality,
            ItemQualityName: Lists.ItemQualityName,
            Brand: Lists.Brand,
            Machine: Lists.Machine,
            Module: Lists.Module,
            Quantity: Lists.Quantity,
            StartTime: Lists.StartTime,
            EndTime: Lists.EndTime,
          }
          LotList.push(Lot)
          Lists.LotList = LotList
        })
        this.tableData = data
        this.List = this.tableData.List
        this.PageSize = this.tableData.PageSize
        this.total = this.tableData.Total
      }).catch((response) => {
        this.IsLoading = false
      })
    },
    handleChange(params) {
      this.pageIndex = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleTabClick({name}) {
      this.currentTab = name
      this.handleSearch()
    },
    initBrand() {
      o('ProductBrand').get()
      .then((data) => {
        console.log('brand', this.Brand)
        // 按顺序遍历品牌排序名数组
        this.sorts.forEach(function(item) {
          // 遍历返回的品牌的集合，找到了遍历的品牌则插入到品牌集合中
          data.data.forEach(function(item2, index) {
            if (item2.Name === item) {
              this.Brand.push(item2)
              // 添加进集合后移除掉已经添加的品牌
              data.data.splice(index, 1)
            }
          }, this)
        }, this)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 当选择品牌后根据品牌名对机型进行二级联动
    changeBrand: function(brandName) {
      // 如果有选中品牌则给初始化机型方法传入品牌名字参数，没有则重新初始化
      if (brandName) {
        this.initModel(brandName)
      } else {
        this.initModel()
      }
    },
    initModel(brandName) {
      this.Machine = []
      let ProductModel = o('ProductModel')
      if (brandName) {
        ProductModel.filter(`contains(Name, '${brandName}')`)
      }
      ProductModel.get().then((data) => {
        // 当有品牌名传入则进行联动排序
        if (brandName) {
          // 根据查询到的排序级别排序.从1开始,找到对应的级别的机型push集合中。遍历结束后push剩下的机型
          const count = data.data.length
          for (let i = 1; i <= count; i++) {
            // 找到对应的排序级别机型
            const insertItem = data.data.find((_) => _.Sort === i)
            // 如果没有该排序级别则不添加
            if (insertItem) {
              this.Machine.push(insertItem)
              // 获取到该机型在原数组中的下标，根据下标移除
              const removeIndex = data.data.findIndex(_ => _.Code === insertItem.Code)
              data.data.splice(removeIndex, 1)
            }
          }
          // 添加剩下的机型
          // data.data.forEach(function(item, index) {
          //   this.ProductModels.push(item)
          // }, this)
        } else {
          this.Machine = data.data
        }
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initModule() {
      o('ProductModule').get()
      .then((response) => {
        this.Module = response.data
      }).catch((err) => {
        console.log(err)
      })
    },
    initRegion() {
      o('Region').get()
      .then((response) => {
        this.Regions = response.data
      }).catch((err) => {
        console.log(err)
      })
    },
  },
  components: {
    ListPageLayout,
    ComplexGrid,
    Countdown,
  },
  created() {
    this.handleSearch()
    this.initBrand()
    this.initModel()
    this.initModule()
    this.initRegion()
    this.initTotal()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
.green{
  color: green;
}
</style>

<style lang="less">
.lease-list-page .el-tabs__active-bar{
  display: none;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
.payment_box{
  position: absolute;
  top:15px;
  right: 15px;
}
</style>




// WEBPACK FOOTER //
// EntrustedIncome_statement.vue?4c14ed0a